export enum Role {
  Standard = 'EDB.STANDARD',
  Locations_T_Systems = 'EDB.LOCATIONS_T-SYSTEMS',
  Locations_Dfmg = 'EDB.LOCATIONS_DFMG',
  Locations_Whitelist = 'EDB.LOCATIONS_WHITELIST',
  Reporting = 'EDB.REPORTING',
  Settings = 'EDB.SETTINGS',
}
